import { render, staticRenderFns } from "./guide-app.vue?vue&type=template&id=b5fd4bf8&scoped=true&"
import script from "./guide-app.vue?vue&type=script&lang=js&"
export * from "./guide-app.vue?vue&type=script&lang=js&"
import style0 from "./guide-app.vue?vue&type=style&index=0&id=b5fd4bf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fd4bf8",
  null
  
)

export default component.exports